<template>
  <div class="container-xl py-5">
    <h2 class="text-center text-secondary">{{ entityDetails.title }}</h2>
    <div class="survey row text-uppercase">
      <ChapterBar :chapter="currentChapter" @clicked="loadForm" />
    </div>
    <div class="w-100 d-flex-column-center my-5">
      <button class="btn btn-primary" @click="loadNexChapter">
        {{ buttonText }}
      </button>
    </div>
    <GuestNotification />
  </div>
</template>

<script>
import ChapterBar from '../../Components/ChapterBar.vue'
import GuestNotification from '../GuestNotification.vue'

export default {
  components: { ChapterBar, GuestNotification },
  props: {
    entityDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    buttonText() {
      return this.entityDetails.isLastChapter
        ? 'Aller à la page de sommaire et résultats'
        : 'Aller au chapitre suivant'
    },
    entityContent() {
      return this.entityDetails.content
    },
    survey() {
      return this.$page.props.survey
    },
    currentSurveyId() {
      return this.survey.id
    },
    currentChapterId() {
      return parseInt(this.$page.props.surveyLevel.chapter)
    },
    surveyChapters() {
      return this.$page.props.surveyQuestions.reduce((map, chapter) => {
        return map.set(chapter.id, chapter)
      }, new Map())
    },
    currentChapter() {
      return this.surveyChapters.get(this.currentChapterId)
    },
    maxScore() {
      let sum = 0
      this.entityContent.forEach((value) => {
        sum += value.questions_count
      })
      return sum * 10
    },
    responsesByQuestionId() {
      return this.$page.props.survey.responses.reduce((map, response) => {
        return map.set(response.survey_question_id, parseInt(response.value))
      }, new Map())
    },
    currentScore() {
      let sum = 0
      this.entityContent.forEach((section) => {
        for (const questionId of section.question_ids) {
          if (this.hasQuestionAnswer(questionId)) {
            sum += this.responsesByQuestionId.get(questionId)
          }
        }
      })
      return sum
    },
  },
  methods: {
    loadForm(surveyLevel) {
      return this.$inertia.visit(
        this.$route('survey.user.show', {
          id: this.currentSurveyId,
        }),
        {
          data: this.getSurveyLevelQuery(surveyLevel),
        }
      )
    },
    loadNexChapter() {
      if (this.entityDetails.isLastChapter) {
        return this.goToSummary()
      }
      return this.$inertia.visit(
        this.$route('survey.user.show', {
          id: this.currentSurveyId,
        }),
        {
          data: { chapitre: this.currentChapterId + 1 },
        }
      )
    },
    goToSummary() {
      this.$inertia.visit(
        this.$route('survey.user.summary', { id: this.currentSurveyId })
      )
    },
    getSurveyLevelQuery(surveyLevel) {
      if (!surveyLevel) {
        return {}
      }
      const levelQuery = {}

      levelQuery.chapitre = this.currentChapterId

      if (!surveyLevel.get('sectionId')) {
        return levelQuery
      }
      levelQuery.section = surveyLevel.get('sectionId')

      if (!surveyLevel.get('themeId')) {
        return levelQuery
      }
      levelQuery.theme = surveyLevel.get('themeId')

      return levelQuery
    },
    hasQuestionAnswer(questionId) {
      return (
        this.responsesByQuestionId.has(questionId) &&
        this.isCountableAnswer(questionId)
      )
    },
    isCountableAnswer(questionId) {
      return !isNaN(this.responsesByQuestionId.get(questionId))
    },
  },
}
</script>
